import React, { useState, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Star, Check, X, ChevronDown, ChevronUp, ShieldCheck, Truck, Package, Plus, Clock, Target, Sliders, ChevronLeft, ChevronRight, ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';

const PRODUCT_ID = '2aa24bcd-956c-491c-a2a5-451f89e9968a';
const PRODUCT_PRICE = 399;
const PRODUCT_IMAGE = '/products/promescent.png';

const playCartSound = () => {
  const audio = new Audio('data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU4Ljc2LjEwMAAAAAAAAAAAAAAA//tQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU4LjEzAAAAAAAAAAAAAAAAJAAAAAAAAAAAAYZNLBruAAAAAAD/+1DEAAAGAAGn9AAAIwwKd/OMACQAABpAAAABQGCAIAh8EAQBAH/BAEAQBA4sIAgCAIHc+ZQEAXP/6gIAgCAJnn/pAEPBA1/84CgIAgGOD//lwGBsMsP/nkQGPgg+f+8MYgIJn+MMDAYGBQM8H//+DBg4f//5wcGIBAED///+UGIIgCDoGJgcf////h+c/////BgxiRq7/2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//tQxAADwAABpAAAACAAADSAAAAE//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8=');
  audio.volume = 0.3;
  audio.play().catch(() => {});
};

const RUNNER_PRODUCTS = [
  {
    id: 'runner-buzzing',
    name: "ג'ל עוררות Buzzing",
    subtitle: 'תפנק את בת הזוג',
    desc: 'תחושת זמזום מעוררת להנאה מוגברת',
    price: 399,
    image: '/products/buzzing.webp',
    badge: null,
    borderColor: 'border-stone-200',
  },
  {
    id: 'runner-warming',
    name: "ג'ל עוררות Warming",
    subtitle: 'תפנק את בת הזוג',
    desc: 'תחושת חימום מעוררת לרגישות מוגברת',
    price: 399,
    image: '/products/warming.webp',
    badge: null,
    borderColor: 'border-stone-200',
  },
  {
    id: 'runner-home-away',
    name: '2 ספריי Delay Spray',
    desc: 'חבילת Home & Away - לבית ולדרך',
    price: 699,
    image: '/products/promescent.png',
    badge: 'מבצע',
    badgeColor: 'bg-red-500',
    borderColor: 'border-[#D97706]',
  },
  {
    id: 'runner-threesome',
    name: '3 ספריי Delay Spray',
    desc: 'חבילת The Threesome - חיסכון מקסימלי',
    price: 989,
    image: '/products/promescent.png',
    badge: 'מבצע',
    badgeColor: 'bg-red-500',
    borderColor: 'border-[#D97706]',
  },
  {
    id: 'runner-b2g-combo',
    name: 'טבליות חיזוק + ספריי השהייה',
    desc: '180 טבליות לחיזוק האון הגברי + ספריי השהייה',
    price: 499,
    image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/vljo25d6_4.png',
    badge: 'חבילה',
    badgeColor: 'bg-green-600',
    borderColor: 'border-green-600',
  },
  {
    id: 'runner-gel-spray',
    name: "ג'ל עוררות + ספריי השהייה",
    desc: 'השילוב המושלם לזוגיות מוצלחת',
    price: 599,
    image: null,
    comboImages: [
      '/products/warming.webp',
      '/products/promescent.png',
    ],
    badge: 'חבילה',
    badgeColor: 'bg-[#2C3E2D]',
    borderColor: 'border-[#2C3E2D]',
  },
  {
    id: 'runner-2-proteins-shaker',
    name: '2 חלבונים + שייקר מתנה',
    desc: 'שני חלבוני מי גבינה איכותיים + שייקר במתנה',
    price: 499,
    image: 'https://images.unsplash.com/photo-1693996045838-980674653385?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxwcm90ZWluJTIwcG93ZGVyJTIwc2hha2VyJTIwYm90dGxlJTIwZml0bmVzcyUyMHN1cHBsZW1lbnR8ZW58MHx8fHwxNzc1NDgzMjA4fDA&ixlib=rb-4.1.0&q=85',
    badge: 'מבצע',
    badgeColor: 'bg-red-500',
    borderColor: 'border-red-500',
  },
  {
    id: 'runner-protein-preworkout',
    name: 'חלבון + קדם אימון',
    desc: 'חבילת אימון מושלמת - חלבון + קדם אימון',
    price: 349,
    image: 'https://images.unsplash.com/photo-1768161680813-615df885ff82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxwcmUlMjB3b3Jrb3V0JTIwc3VwcGxlbWVudCUyMHBvd2RlciUyMGd5bXxlbnwwfHx8fDE3NzU0ODMyMDl8MA&ixlib=rb-4.1.0&q=85',
    badge: 'מבצע',
    badgeColor: 'bg-red-500',
    borderColor: 'border-red-500',
  },
  {
    id: 'runner-creatine-preworkout-protein',
    name: 'קראטין + קדם אימון + חלבון',
    desc: 'חבילת הכל כלול + שייקר מתנה!',
    price: 499,
    image: 'https://images.unsplash.com/photo-1693996045899-7cf0ac0229c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxwcm90ZWluJTIwcG93ZGVyJTIwc2hha2VyJTIwYm90dGxlJTIwZml0bmVzcyUyMHN1cHBsZW1lbnR8ZW58MHx8fHwxNzc1NDgzMjA4fDA&ixlib=rb-4.1.0&q=85',
    badge: 'חבילה + מתנה',
    badgeColor: 'bg-green-600',
    borderColor: 'border-green-600',
  },
  {
    id: 'runner-2proteins-preworkout',
    name: '2 חלבונים + קדם אימון',
    desc: 'שני חלבונים איכותיים + קדם אימון לביצועים מקסימליים',
    price: 449,
    image: 'https://images.unsplash.com/photo-1704650311981-419f841421cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxwcmUlMjB3b3Jrb3V0JTIwc3VwcGxlbWVudCUyMHBvd2RlciUyMGd5bXxlbnwwfHx8fDE3NzU0ODMyMDl8MA&ixlib=rb-4.1.0&q=85',
    badge: 'מבצע',
    badgeColor: 'bg-red-500',
    borderColor: 'border-red-500',
  },
  {
    id: 'runner-protein-bars-10',
    name: 'חטיפי חלבון 38 גרם - 9+1',
    desc: '9 חטיפי חלבון אול אין 38 גרם + ה-10 חינם!',
    price: 153,
    image: 'https://images.unsplash.com/photo-1772986509919-61b14bf702fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxwcm90ZWluJTIwYmFycyUyMHNuYWNrJTIwZml0bmVzcyUyMGhpZ2glMjBwcm90ZWlufGVufDB8fHx8MTc3NTQ4MzIxMXww&ixlib=rb-4.1.0&q=85',
    badge: '9+1 חינם!',
    badgeColor: 'bg-[#D97706]',
    borderColor: 'border-[#D97706]',
  },
];

const RunnerCarousel = ({ navigate, addToCart }) => {
  const scrollRef = useRef(null);
  const [addedItems, setAddedItems] = useState({});

  const scroll = useCallback((direction) => {
    const el = scrollRef.current;
    if (!el) return;
    const cardWidth = 276;
    const amount = direction === 'left' ? -cardWidth : cardWidth;
    el.scrollBy({ left: amount, behavior: 'smooth' });
    // After scroll finishes, check if we need to loop
    setTimeout(() => {
      if (!el) return;
      const halfWidth = el.scrollWidth / 2;
      if (el.scrollLeft >= halfWidth) {
        el.scrollLeft = el.scrollLeft - halfWidth;
      } else if (el.scrollLeft <= 0) {
        el.scrollLeft = el.scrollLeft + halfWidth;
      }
    }, 350);
  }, []);

  const handleAddToCart = (product) => {
    addToCart({
      id: product.id,
      name: product.name,
      price: product.price,
      image: product.image || product.comboImages?.[0] || '',
    });
    playCartSound();
    toast.success('נוסף לסל!');
    setAddedItems(prev => ({ ...prev, [product.id]: true }));
  };

  return (
    <div className="relative px-4 md:px-8">
      {/* Left Arrow */}
      <button
        onClick={() => scroll('left')}
        data-testid="runner-arrow-left"
        className="absolute left-1 md:left-2 top-1/2 -translate-y-1/2 z-10 w-11 h-11 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-stone-100 hover:scale-110 transition-all border border-stone-200"
      >
        <ChevronLeft className="w-6 h-6 text-[#2C3E2D]" />
      </button>

      {/* Cards Container */}
      <div
        ref={scrollRef}
        className="flex gap-4 overflow-x-auto scrollbar-hide scroll-smooth px-12"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none', WebkitOverflowScrolling: 'touch', direction: 'ltr' }}
        data-testid="runner-cards-container"
      >
        <style>{`.scrollbar-hide::-webkit-scrollbar { display: none; }`}</style>
        {[...Array(2)].map((_, dup) =>
          RUNNER_PRODUCTS.map((product, i) => (
            <div
              key={`${dup}-${product.id}`}
              className={`flex-shrink-0 w-[260px] bg-white rounded-2xl ${product.borderColor} border shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden relative group`}
              data-testid={`runner-card-${product.id}`}
            >
              {product.badge && (
                <div className={`absolute top-2 right-2 ${product.badgeColor} text-white text-[10px] font-bold px-2.5 py-1 rounded-full z-10`}>
                  {product.badge}
                </div>
              )}
              <div className="h-[200px] bg-gradient-to-b from-stone-50 to-white flex items-center justify-center p-3">
                {product.comboImages ? (
                  <div className="flex items-center justify-center gap-0">
                    <img src={product.comboImages[0]} alt="" className="max-h-[120px] w-auto object-contain" />
                    <span className="text-2xl font-bold text-[#D97706] mx-1">+</span>
                    <img src={product.comboImages[1]} alt="" className="max-h-[120px] w-auto object-contain" />
                  </div>
                ) : (
                  <img src={product.image} alt={product.name} className="max-h-full max-w-full object-contain" />
                )}
              </div>
              <div className="p-4 text-center" style={{ direction: 'rtl' }}>
                <h3 className="font-bold text-[#2C3E2D] text-sm mb-1" style={{ fontFamily: 'Heebo, sans-serif' }}>
                  {product.name}
                </h3>
                {product.subtitle && (
                  <p className="text-xs font-semibold text-[#D97706] mb-1">{product.subtitle}</p>
                )}
                <p className="text-xs text-stone-500 mb-2 line-clamp-2">{product.desc}</p>
                <span className="text-xl font-black text-[#D97706]">{product.price} &#8362;</span>
                <div className="mt-3">
                  {addedItems[product.id] ? (
                    <button
                      onClick={() => navigate('/cart')}
                      data-testid={`runner-go-cart-${product.id}`}
                      className="w-full h-10 rounded-full bg-[#2C3E2D] text-white text-sm font-bold flex items-center justify-center gap-2 hover:bg-[#1a2a1b] transition-colors"
                      style={{ fontFamily: 'Heebo, sans-serif' }}
                    >
                      <ShoppingCart className="w-4 h-4" />
                      מעבר לרכישה
                    </button>
                  ) : (
                    <button
                      onClick={() => handleAddToCart(product)}
                      data-testid={`runner-add-cart-${product.id}`}
                      className="w-full h-10 rounded-full bg-[#D97706] text-white text-sm font-bold flex items-center justify-center gap-2 hover:bg-[#b86005] transition-colors"
                      style={{ fontFamily: 'Heebo, sans-serif' }}
                    >
                      <Plus className="w-4 h-4" />
                      הוסף לסל
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Right Arrow */}
      <button
        onClick={() => scroll('right')}
        data-testid="runner-arrow-right"
        className="absolute right-1 md:right-2 top-1/2 -translate-y-1/2 z-10 w-11 h-11 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-stone-100 hover:scale-110 transition-all border border-stone-200"
      >
        <ChevronRight className="w-6 h-6 text-[#2C3E2D]" />
      </button>
    </div>
  );
};

const faqData = [
  {
    q: 'האם ספריי ההשהייה באמת עובד?',
    a: 'מחקר קליני מאושר הראה כי Promescent יעיל בהארכת הזמן עד לגמירה. לתוצאות הטובות ביותר, רססו 3-10 ריסוסים על ראש האיבר והחלק התחתון של הגוף, שפשפו עד שיתייבש, והמתינו 5-10 דקות לפני קיום יחסים.'
  },
  {
    q: 'כמה זמן נמשכת ההשפעה?',
    a: 'השפעת ההרדמה נמשכת בדרך כלל כשעה לאחר המריחה. התוצאות משתנות בהתאם לרמת הרגישות ולכמות המוצר שבשימוש.'
  },
  {
    q: 'האם יש תופעות לוואי?',
    a: 'מוצרי הרדמה גניטלית לגברים מוכרים בדרך כלל כבטוחים ויעילים לשפיכה מוקדמת עם מעט תופעות לוואי. במידה ומתפתח גירוי או פריחה, הפסיקו את השימוש ופנו לרופא.'
  },
  {
    q: 'האם ניתן להשתמש יחד עם קונדום או חומר סיכה?',
    a: 'כן, ניתן להשתמש עם כל סוגי חומרי הסיכה, ותואם לקונדומים מלטקס ופוליאיזופרן. המתינו 5-10 דקות לספיגה מלאה לפני השימוש בקונדום.'
  },
  {
    q: 'האם המוצר ישפיע על בת/בן הזוג?',
    a: 'Promescent משתמש בטכנולוגיית Anti-Transfer פטנטית שמונעת העברת ההרדמה לבן/בת הזוג בשימוש לפי ההוראות. אם מתוכנן מגע אוראלי, מומלץ לנגב את האזור המטופל לאחר זמן ההמתנה.'
  },
  {
    q: 'האם הספריי יפחית את ההנאה שלי?',
    a: 'לא, אם מכיילים את המינון נכון. התחילו עם 3 ריסוסים על ראש האיבר, שפשפו עד שיתייבש, והמתינו 5-10 דקות. ניתן להתאים עד מקסימום 10 ריסוסים. הפורמולה מיועדת להישאר במקום המריחה לתחושה טבעית יותר.'
  },
  {
    q: 'כמה ריסוסים מומלץ להשתמש?',
    a: 'התחילו עם 3 ריסוסים והתאימו בהתאם לצורך, עד מקסימום 10 ריסוסים. כל גבר שונה - המפתח הוא למצוא את המינון האישי המושלם עבורכם.'
  }
];

const reviews = [
  { name: 'דוד מ.', rating: 5, text: 'מוצר מעולה. באמת עוזר ומשנה את חוויית הביצועים לחלוטין.', date: 'לפני 3 ימים' },
  { name: 'אבי ק.', rating: 5, text: 'עובד מצוין! קל לשימוש ובלי תופעות לוואי.', date: 'לפני שבוע' },
  { name: 'יוסי ל.', rating: 5, text: 'שינוי דרמטי. הרגשתי הבדל כבר מהשימוש הראשון. ממליץ בחום!', date: 'לפני שבוע' },
  { name: 'רון ש.', rating: 4, text: 'עובד טוב מאוד. צריך קצת להתרגל למינון הנכון אבל התוצאות מדהימות.', date: 'לפני שבועיים' },
  { name: 'משה כ.', rating: 5, text: 'המוצר הכי טוב שניסיתי בקטגוריה. שווה כל שקל.', date: 'לפני שבועיים' },
];

const PromescentPage = () => {
  const navigate = useNavigate();
  const { addToCart, cart } = useCart();
  const [openFaq, setOpenFaq] = useState(null);
  const [isAdded, setIsAdded] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const isInCart = cart.some(item => item.id === PRODUCT_ID);

  const handleAddToCart = () => {
    if (isAdded || isInCart) {
      navigate('/cart');
      return;
    }
    addToCart({
      id: PRODUCT_ID,
      name: 'Promescent - ספריי השהייה',
      price: PRODUCT_PRICE,
      image: PRODUCT_IMAGE,
      description: 'ספריי מקצועי להארכת משך היחסים',
      category: 'חיזוק האון'
    });
    setIsAdded(true);
    playCartSound();
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 2000);
    toast.success('נוסף לסל!');
  };

  return (
    <div className="bg-white" data-testid="promescent-page">
      {/* Cart Popup */}
      {showPopup && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 bg-green-500 text-white px-8 py-4 rounded-2xl shadow-2xl flex items-center gap-3 animate-slide-down" data-testid="cart-popup">
          <Check className="w-6 h-6" />
          <span className="font-bold text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>נוסף לסל</span>
        </div>
      )}

      {/* Hero Section */}
      <section className="py-8 md:py-16 bg-gradient-to-b from-stone-50 to-white">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-start">
            {/* Product Image */}
            <div className="flex flex-col items-center">
              <div className="bg-white rounded-3xl p-8 shadow-sm border border-stone-100 w-full max-w-md">
                <img
                  src={PRODUCT_IMAGE}
                  alt="Promescent Delay Spray"
                  className="w-full h-auto object-contain"
                  data-testid="promescent-hero-image"
                />
              </div>
              {/* Trust Badges under image */}
              <div className="flex items-center gap-6 mt-6 text-sm text-stone-500">
                <div className="flex items-center gap-2">
                  <Truck className="w-5 h-5 text-[#D97706]" />
                  <span>משלוח דיסקרטי</span>
                </div>
                <div className="flex items-center gap-2">
                  <Package className="w-5 h-5 text-[#D97706]" />
                  <span>אריזה נייטרלית</span>
                </div>
              </div>
            </div>

            {/* Product Info */}
            <div className="space-y-6 text-right">
              <div>
                <span className="inline-block bg-[#D97706]/10 text-[#D97706] text-sm font-semibold px-3 py-1 rounded-full mb-3" style={{ fontFamily: 'Heebo, sans-serif' }}>
                  ספריי השהייה
                </span>
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="promescent-title">
                  Promescent - ספריי השהייה
                </h1>
                <p className="text-lg text-stone-600">שליטה מלאה. הנאה מקסימלית.</p>
              </div>

              {/* Rating */}
              <div className="flex items-center gap-3" data-testid="promescent-rating">
                <div className="flex items-center gap-1">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className={`w-5 h-5 ${i < 5 ? 'fill-[#D97706] text-[#D97706]' : 'text-stone-300'}`} />
                  ))}
                </div>
                <span className="font-bold text-[#2C3E2D]">4.7</span>
                <span className="text-stone-500 text-sm">(3,002 ביקורות)</span>
              </div>

              {/* Key Benefits */}
              <div className="bg-stone-50 rounded-2xl p-6 space-y-3">
                <p className="font-bold text-[#2C3E2D] text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>
                  מחקר קליני הראה עלייה של 50% בהגעה משותפת לאורגזמה
                </p>
                <ul className="space-y-2.5">
                  <li className="flex items-start gap-3">
                    <Check className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span className="text-stone-700 font-bold">מעכב שפיכה הטוב בעולם</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Check className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span className="text-stone-700 font-bold">מומלץ על ידי רופאים ואורולוגים</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Check className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <div>
                      <span className="font-bold text-[#2C3E2D]">טכנולוגיית Anti-Transfer</span>
                      <p className="text-stone-500 text-sm">לא עובר לבן/בת הזוג בשימוש לפי ההוראות</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <Check className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span className="text-stone-700 font-bold">ארוך טווח וקל לשימוש</span>
                  </li>
                </ul>
              </div>

              {/* Price & Add to Cart */}
              <div className="space-y-4">
                <div className="flex items-baseline gap-3">
                  <span className="text-4xl font-black text-[#D97706]" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="promescent-price">
                    ₪{PRODUCT_PRICE}
                  </span>
                  <span className="text-stone-400 line-through text-lg">₪489</span>
                  <span className="bg-red-100 text-red-600 text-sm font-bold px-2 py-0.5 rounded-full">
                    חסכון ₪90
                  </span>
                </div>

                <button
                  onClick={handleAddToCart}
                  data-testid="promescent-add-to-cart"
                  className={`w-full py-4 rounded-2xl font-bold text-lg transition-all duration-300 flex items-center justify-center gap-3 ${
                    isAdded || isInCart
                      ? 'bg-green-500 hover:bg-green-600 text-white'
                      : 'bg-[#D97706] hover:bg-[#B45309] text-white hover:shadow-lg hover:-translate-y-0.5'
                  }`}
                  style={{ fontFamily: 'Heebo, sans-serif' }}
                >
                  {isAdded || isInCart ? (
                    <>
                      <Check className="w-6 h-6" />
                      מעבר לרכישה
                    </>
                  ) : (
                    <>
                      <Plus className="w-6 h-6" />
                      מעבר למבצעים חמים
                    </>
                  )}
                </button>

                {/* No guarantee line - removed */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Runner - Arrow Navigation */}
      <section className="py-12 bg-white overflow-hidden" data-testid="product-runner">
        <div className="container mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-[#2C3E2D]" style={{ fontFamily: 'Heebo, sans-serif' }}>
            עוד מוצרים של Promescent
          </h2>
        </div>
        <RunnerCarousel navigate={navigate} addToCart={addToCart} />
      </section>

      {/* How It Works */}
      <section className="py-16 bg-[#F5F5F4]" data-testid="how-it-works">
        <div className="container">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
            איך Promescent עובד?
          </h2>
          <p className="text-center text-stone-600 mb-12 text-lg">שלושה שלבים פשוטים לביצועים טובים יותר</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                step: '1',
                title: 'אותות עצבים מעוררים אורגזמה',
                desc: 'באיבר הגברי יש מעל 6,000 קצוות עצב. במהלך יחסים, העצבים שולחים אותות לגוף להגיע לשיא. גברים עם רגישות גבוהה יותר צריכים פתרון נוסף.',
                icon: <Target className="w-8 h-8" />
              },
              {
                step: '2',
                title: 'Promescent מרגיע תאי עצב',
                desc: 'ספריי הלידוקאין נספג בעור ומגביל זמנית את גירוי תאי העצב, מאט את קצב העברת האותות. זה נותן לך שליטה מלאה.',
                icon: <Sliders className="w-8 h-8" />
              },
              {
                step: '3',
                title: 'מורחים היכן שצריך',
                desc: 'רססו על ראש האיבר ותחתית הגוף. ההשפעה מתחילה תוך 5-10 דקות ונמשכת עד שעה. פשוט שוטפים אחרי.',
                icon: <Clock className="w-8 h-8" />
              }
            ].map((item, i) => (
              <div key={i} className="bg-white rounded-2xl p-8 text-center shadow-sm hover:shadow-md transition-shadow">
                <div className="w-16 h-16 bg-[#D97706]/10 rounded-full flex items-center justify-center mx-auto mb-4 text-[#D97706]">
                  {item.icon}
                </div>
                <div className="w-8 h-8 bg-[#D97706] text-white rounded-full flex items-center justify-center mx-auto mb-3 text-sm font-bold">
                  {item.step}
                </div>
                <h3 className="text-xl font-bold text-[#2C3E2D] mb-3" style={{ fontFamily: 'Heebo, sans-serif' }}>
                  {item.title}
                </h3>
                <p className="text-stone-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <section className="py-16" data-testid="comparison-section">
        <div className="container max-w-4xl">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#2C3E2D] mb-12" style={{ fontFamily: 'Heebo, sans-serif' }}>
            למה Promescent?
          </h2>

          <div className="grid grid-cols-2 gap-4 md:gap-8">
            {/* Promescent Column */}
            <div className="bg-green-50 rounded-2xl p-6 border-2 border-green-200">
              <h3 className="text-xl font-bold text-center text-green-700 mb-6" style={{ fontFamily: 'Heebo, sans-serif' }}>
                Promescent
              </h3>
              <div className="space-y-4">
                {[
                  'טכנולוגיית ספיגה מתקדמת - נשאר במקום המריחה',
                  'טכנולוגיית Anti-Transfer - לא משפיע על בן/בת הזוג',
                  'פורמולה חדשה ופטנטית - פותחה על ידי אורולוגים מובילים',
                  'מינון מותאם אישית - שליטה מלאה'
                ].map((text, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <Check className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" />
                    <span className="text-sm text-stone-700">{text}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Other Brands Column */}
            <div className="bg-red-50 rounded-2xl p-6 border-2 border-red-200">
              <h3 className="text-xl font-bold text-center text-red-600 mb-6" style={{ fontFamily: 'Heebo, sans-serif' }}>
                מותגים אחרים
              </h3>
              <div className="space-y-4">
                {[
                  'ספיגה לא צפויה - סיכון גבוה להרדמה מוגזמת',
                  'מעבר לבן/בת הזוג סביר - מפחית את ההנאה',
                  'אותה פורמולה ישנה משנות ה-70',
                  'מינון אחיד - ללא התאמה אישית'
                ].map((text, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <X className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" />
                    <span className="text-sm text-stone-700">{text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Recommendation Section */}
      <section className="py-16 bg-[#1a2332] text-white" data-testid="doctors-section">
        <div className="container">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-3" style={{ fontFamily: 'Heebo, sans-serif' }}>
            מומלץ על ידי רופאים ואורולוגים
          </h2>
          <p className="text-center text-stone-300 mb-12 text-base max-w-2xl mx-auto leading-relaxed">
            לא רק משתמשי Promescent אוהבים אותנו. ראו מדוע מעל 4,000 אנשי מקצוע בתחום הבריאות ממליצים עלינו בשמם.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {[
              {
                name: 'ד"ר רונלד גילברט',
                title: 'מייסד Promescent',
                desc: 'מייסד Promescent, לנכת. ד"ר גילברט קיבל השראה לספק טיפול יעיל לשפיכה מוקדמת למטופלין, ופיתח את תרסיס ההשהייה של Promescent.',
                image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/h7zvnx7x_Dr._Ronald_Gilbert_M.D_354x.webp'
              },
              {
                name: 'ד"ר לורנס לוין, MD',
                title: 'קצין הרפואה הראשי',
                desc: 'קצין הרפואה הראשי של פרומסנט, פרופסור לאורולוגיה ומשא משותף ב-Urology Specialists. ד"ר לוין הוא אורולוג פעיל עם למעלה מ-25 שנות ניסיון.',
                image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/78jv9v8t_Dr._Laurence_Levine_M.D_354x.webp'
              },
              {
                name: 'ד"ר רייצ\'ל רובין',
                title: 'יועצת רפואית',
                desc: 'יועצת רפואית של Promescent, אורולוגית מוסמכת, יו"ר חינוך באגודה הבינלאומית לחקר בריאות מינית של נשים (ISSWSH).',
                image: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/yx6nvt59_Dr._Rachel_Rubin_M.D_354x.webp'
              }
            ].map((doc, i) => (
              <div key={i} className="text-center" data-testid={`doctor-card-${i}`}>
                <div className="bg-white/10 rounded-2xl p-4 mb-4 inline-block mx-auto">
                  <img
                    src={doc.image}
                    alt={doc.name}
                    className="w-48 h-48 md:w-56 md:h-56 object-cover rounded-xl mx-auto"
                  />
                </div>
                <h3 className="text-xl font-bold mb-1" style={{ fontFamily: 'Heebo, sans-serif' }}>
                  {doc.name}
                </h3>
                <p className="text-[#D97706] text-sm font-semibold mb-3">{doc.title}</p>
                <p className="text-stone-300 text-sm leading-relaxed px-2">
                  {doc.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Discreet Shipping */}
      <section className="py-12 bg-stone-50">
        <div className="container">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 text-center md:text-right">
            <div className="w-20 h-20 bg-[#D97706]/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Package className="w-10 h-10 text-[#D97706]" />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>
                משלוח דיסקרטי ופרטי
              </h3>
              <p className="text-stone-600 text-lg">
                כל המוצרים נשלחים באריזה נייטרלית ופשוטה ללא שם המוצר. הפרטיות שלך מובטחת.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16" data-testid="faq-section">
        <div className="container max-w-3xl">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#2C3E2D] mb-12" style={{ fontFamily: 'Heebo, sans-serif' }}>
            שאלות נפוצות
          </h2>

          <div className="space-y-3">
            {faqData.map((faq, i) => (
              <div
                key={i}
                className="bg-white border border-stone-200 rounded-xl overflow-hidden"
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  className="w-full flex items-center justify-between p-5 text-right hover:bg-stone-50 transition-colors"
                >
                  <span className="font-semibold text-[#2C3E2D] text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>
                    {faq.q}
                  </span>
                  {openFaq === i ? (
                    <ChevronUp className="w-5 h-5 text-[#D97706] flex-shrink-0" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-stone-400 flex-shrink-0" />
                  )}
                </button>
                {openFaq === i && (
                  <div className="px-5 pb-5 text-stone-600 leading-relaxed border-t border-stone-100 pt-4">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Reviews Section */}
      <section className="py-16 bg-[#F5F5F4]" data-testid="reviews-section">
        <div className="container max-w-4xl">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
            ביקורות לקוחות
          </h2>

          {/* Rating Summary */}
          <div className="flex items-center justify-center gap-4 mb-10">
            <div className="text-center">
              <span className="text-5xl font-black text-[#D97706]">4.7</span>
              <div className="flex items-center gap-1 mt-1 justify-center">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#D97706] text-[#D97706]" />
                ))}
              </div>
              <p className="text-stone-500 text-sm mt-1">מבוסס על 3,002 ביקורות</p>
            </div>
          </div>

          {/* Rating Bars */}
          <div className="max-w-sm mx-auto mb-10 space-y-2">
            {[
              { stars: 5, pct: 76 },
              { stars: 4, pct: 17 },
              { stars: 3, pct: 6 },
              { stars: 2, pct: 1 },
              { stars: 1, pct: 0 }
            ].map((row) => (
              <div key={row.stars} className="flex items-center gap-3">
                <span className="text-sm text-stone-500 w-4">{row.stars}</span>
                <Star className="w-4 h-4 fill-[#D97706] text-[#D97706]" />
                <div className="flex-1 h-2.5 bg-stone-200 rounded-full overflow-hidden">
                  <div className="h-full bg-[#D97706] rounded-full" style={{ width: `${row.pct}%` }} />
                </div>
                <span className="text-sm text-stone-500 w-10">{row.pct}%</span>
              </div>
            ))}
          </div>

          {/* Individual Reviews */}
          <div className="space-y-4">
            {reviews.map((review, i) => (
              <div key={i} className="bg-white rounded-xl p-6 shadow-sm" data-testid={`review-${i}`}>
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-[#D97706]/10 rounded-full flex items-center justify-center font-bold text-[#D97706]">
                      {review.name.charAt(0)}
                    </div>
                    <div>
                      <p className="font-semibold text-[#2C3E2D]" style={{ fontFamily: 'Heebo, sans-serif' }}>{review.name}</p>
                      <div className="flex items-center gap-1">
                        {[...Array(review.rating)].map((_, j) => (
                          <Star key={j} className="w-3.5 h-3.5 fill-[#D97706] text-[#D97706]" />
                        ))}
                      </div>
                    </div>
                  </div>
                  <span className="text-sm text-stone-400">{review.date}</span>
                </div>
                <p className="text-stone-600 leading-relaxed">"{review.text}"</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sticky Bottom CTA - Mobile */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-stone-200 p-4 z-40 lg:hidden" data-testid="sticky-cta">
        <div className="flex items-center gap-4">
          <div className="flex-1">
            <p className="font-bold text-[#2C3E2D] text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>
              ₪{PRODUCT_PRICE}
            </p>
            <p className="text-sm text-stone-500">Promescent - ספריי השהייה</p>
          </div>
          <button
            onClick={handleAddToCart}
            data-testid="sticky-add-to-cart"
            className={`px-8 py-3 rounded-xl font-bold transition-all ${
              isAdded || isInCart
                ? 'bg-green-500 text-white'
                : 'bg-[#D97706] text-white hover:bg-[#B45309]'
            }`}
            style={{ fontFamily: 'Heebo, sans-serif' }}
          >
            {isAdded || isInCart ? 'לרכישה' : 'למבצעים חמים'}
          </button>
        </div>
      </div>

      {/* Bottom spacer for sticky CTA on mobile */}
      <div className="h-20 lg:hidden" />
    </div>
  );
};

export default PromescentPage;
